import type { HostCapabilities } from "./index";

export const createBrowserCapabilities = (
  options: { screenId?: number; href?: string } = {},
): HostCapabilities => {
  const fromHref = options.href
    ? Number(new URL(options.href).searchParams.get("screen"))
    : NaN;
  const screenId =
    options.screenId ??
    (Number.isInteger(fromHref) && fromHref > 0 ? fromHref : 1);
  return {
    screens: {
      current: () => screenId,
      displays: async () => [],
      getScreenArrangement: async (screenIds) => ({
        order: screenIds,
        positions: Object.fromEntries(
          screenIds.map((id, index) => [id, { row: 0, col: index }]),
        ),
      }),
    },
    windows: null,
    files: null,
    updater: null,
  };
};
